import { useState } from 'react'

import Banner from '../../components/banner/Banner'
import Nav from '../../components/nav/Nav'
import Aside from '../../components/aside/Aside'
import Pages from '../controller/Pages'

import './content.css'

const Content = ({data}) => {
      
      const [current, setCurrent] = useState('home')
      const [show, setShow] = useState(false)
      
      if(data.length === 0) return 

      
      const {infordata, banners} = data.user 
      
      return (
            <div className="content">
                  <Banner data={banners} />
                  <Nav data={infordata} isCurrent={current} isSetCurrent={setCurrent} isSetShow={setShow} />
                  <Pages data={data} isCurrent={current} isSetCurrent={setCurrent} isShow={show} isSetShow={setShow} />
                  <Aside data={data} />
            </div>
      )
}

export default Content
